function requireAll(r) {
  r.keys().forEach(r);
}

const pageBody = document.querySelector('body');
const pageWrapper = document.querySelector('.lp25-page-wrapper');
const heroSection = pageWrapper.querySelector('.hero-section');

const state = {
  scrollY: 0,
  windowHeight: window.innerHeight,
  pageHeight: pageWrapper.offsetHeight
};

const updateVH = () => {
  const vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

const updatePageDimensions = () => {
  heroSection.style.width = `${pageWrapper.offsetWidth}px`;
  state.windowHeight = window.innerHeight;
  state.pageHeight = pageWrapper.offsetHeight;
};

const handleResize = () => {
  updateVH();
  updatePageDimensions();
  window.dispatchEvent(new Event('scroll'));
};

const switchImages = () => {
  const frames = document.querySelectorAll('.lp25-page-wrapper .frames');
  frames.forEach((frame, index) => {
    const images = frame.querySelectorAll('.frame');
    let currentIndex = 0;
    setInterval(() => {
      images[currentIndex].classList.remove('active');
      currentIndex = (currentIndex + 1) % images.length;
    
      images[currentIndex].classList.add('active');
    }, 500);
  });
};

const textBarAnim = () => {
  const textBar = document.querySelector('.lp25-page-wrapper .text-bar__inner');
  let textBarX = 0;
  setInterval(() => {
    textBarX = (textBarX + 2) % 100;
    textBar.style.transform = `translateX(-${textBarX}%)`;
  }, 200);
};

const splitTextForAnimation = () => {
  const titles = document.querySelectorAll('.lp25-page-wrapper .look__title');
  titles.forEach(title => {
    const originalHTML = title.innerHTML;
    const placeholder = '%%BR%%';
    const tempHTML = originalHTML.replace(/<br\s*\/?>/gi, placeholder);
    const parts = tempHTML.split(/(%%BR%%)/);
    const wrappedHTML = parts.map(part => 
      part === '%%BR%%' ? '<br>' : [...part].map(char => `<span>${char}</span>`).join('')
    ).join('');
    title.innerHTML = wrappedHTML;
  });
};

const typeWriter = element => {
  const letters = element.querySelectorAll('span');
  letters.forEach((letter, index) => {
    setTimeout(() => {
      letter.classList.add('active');
    }, index * 100);
  });
};

const timer = (func, delay) => setTimeout(func, delay);

const init = () => {
  pageWrapper.classList.remove('loaded');
  timer(() => pageWrapper.classList.add('loaded'), 1100);

  switchImages();
  textBarAnim();
  window.dispatchEvent(new Event('scroll'));

  const svgPaths = document.querySelectorAll('.lp25-page-wrapper .page-title svg path');
  svgPaths.forEach((path, index) => {
    timer(() => path.classList.add('active'), index * 100 + 1000);
  });
};

const handleScroll = () => {
  state.scrollY = window.scrollY;
  heroSection.style.transform = `translateY(${state.scrollY * 0.5}px)`;

  document.querySelectorAll('.lp25-page-wrapper .look-section').forEach(section => {
    section.classList.toggle('inview', section.getBoundingClientRect().top <= 0);
  });

  document.querySelectorAll('.lp25-page-wrapper .look__title').forEach(title => {
    const titleY = title.getBoundingClientRect().top;
    if (!title.classList.contains('executed') && titleY <= state.windowHeight * 0.5) {
      title.classList.add('executed');
      typeWriter(title);
    }
  });

  const scrollBottom = state.scrollY + state.windowHeight;
  const gap = Math.min(0, state.pageHeight - scrollBottom);

  document.querySelectorAll('.lp25-page-wrapper .col:first-child').forEach(item => {
    item.style.transform = state.pageHeight <= scrollBottom ? `translateY(${gap}px)` : 'translateY(0)';
  });
};

window.addEventListener('load', () => {
  handleResize();
  handleScroll();
  init();
  splitTextForAnimation();
});

window.addEventListener('resize', handleResize);
window.addEventListener('scroll', handleScroll);
